export default "__VITE_ASSET__BLt6_31c__"